/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * Type of meter reading
 */
export type MeterReadingType =
  (typeof MeterReadingType)[keyof typeof MeterReadingType]

export const MeterReadingType = {
  First: "First",
  Normal: "Normal",
} as const
